import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories, categoryComics } from '@/mocks/categoryData';

export default function Category() {
  const [activeCategory, setActiveCategory] = useState('全部');
  const [sortBy, setSortBy] = useState('热门');

  const filteredComics = activeCategory === '全部'
    ? categoryComics
    : categoryComics.filter((c) => c.category === activeCategory);

  const sortedComics = [...filteredComics].sort((a, b) => {
    if (sortBy === '热门') return parseFloat(b.views.replace('亿', '').replace('万', '')) - parseFloat(a.views.replace('亿', '').replace('万', ''));
    if (sortBy === '评分最高') return b.rating - a.rating;
    if (sortBy === '最新') return parseInt(b.chapters) - parseInt(a.chapters);
    return 0;
  });

  const collectionJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: '韩国漫画大全 - 分类浏览',
    description: '按题材分类浏览所有韩国漫画，包括恋爱、奇幻、动作、悬疑等全品类',
    url: 'http://yashisz.com/category',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫漫画网站',
      url: 'http://yashisz.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(collectionJsonLd)}</script>
      <Navbar />
      <main className="pt-16 md:pt-18">
        <div className="bg-background-100 py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '漫画大全' },
                ]}
              />
            </div>
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
              漫画大全
            </h1>
            <p className="text-foreground-500 text-sm mt-3">
              探索所有韩国漫画，按题材分类浏览，发现你的下一部最爱
            </p>

            <div className="flex flex-wrap gap-2 mt-7">
              <button
                onClick={() => setActiveCategory('全部')}
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  activeCategory === '全部'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:text-foreground-950'
                }`}
              >
                全部
              </button>
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.name)}
                  className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.name
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-50 text-foreground-600 hover:text-foreground-950'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                  {cat.name}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <p className="text-sm text-foreground-500">
                共 <strong className="text-foreground-950">{sortedComics.length}</strong> 部作品
              </p>
              <div className="flex items-center gap-2">
                <span className="text-xs text-foreground-400">排序：</span>
                {['热门', '评分最高', '最新'].map((s) => (
                  <button
                    key={s}
                    onClick={() => setSortBy(s)}
                    className={`px-3 py-1 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
                      sortBy === s
                        ? 'bg-secondary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:text-foreground-950'
                    }`}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
              {sortedComics.map((comic) => (
                <Link
                  key={comic.id}
                  to="/"
                  className="group cursor-pointer"
                >
                  <div className="rounded-xl overflow-hidden bg-background-100 mb-3">
                    <div className="aspect-[2/3] overflow-hidden">
                      <img
                        src={comic.coverImage}
                        alt={comic.title}
                        title={`${comic.title} - 韩漫漫画网站`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-950 group-hover:text-accent-500 transition-colors truncate">
                    {comic.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                    <span className="flex items-center gap-0.5">
                      <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                      {comic.rating}
                    </span>
                    <span>{comic.status}</span>
                  </div>
                </Link>
              ))}
            </div>

            {sortedComics.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500">暂无该分类的漫画，请尝试其他分类</p>
              </div>
            )}
          </div>
        </div>

        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
              浏览全部分类
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.name)}
                  className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 hover:bg-accent-50 transition-colors cursor-pointer"
                >
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className={`${cat.icon} text-xl`}></i>
                  </span>
                  <span className="text-sm font-medium text-foreground-950">{cat.name}</span>
                  <span className="text-xs text-foreground-500">{cat.count}部</span>
                </button>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}